import { render, staticRenderFns } from "./kolCardActivityDetail.vue?vue&type=template&id=b5f947da&scoped=true"
import script from "./kolCardActivityDetail.vue?vue&type=script&lang=js"
export * from "./kolCardActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./kolCardActivityDetail.vue?vue&type=style&index=0&id=b5f947da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f947da",
  null
  
)

export default component.exports